export const LineRels = {
    getLines: 'getLines'
};
